// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'

Vue.use(Vuex)
import 'babel-polyfill'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
import axios from 'axios'
import $ from 'jquery'
import store from './store/store'
import 'animate.css/animate.min.css'
import {WOW} from 'wowjs'
// import VueAwesomeSwiper from 'vue-awesome-swiper'


// Vue.use(VueAwesomeSwiper)
// import 'swiper/dist/css/swiper.css';
// import 'swiper/dist/js/swiper.js';
import router from './router'

import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad,{
  error:'./static/img/error.png',
  loading:'./static/img/error.png',
})


Vue.config.productionTip = false

/* eslint-disable no-new */

Vue.prototype.$axios = axios;

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  components: {App},
  template: '<App/>',
})

new WOW({live: false}).init();

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});


Vue.filter('years-month', function (value) {
  if (value == null) return 'yyyy-mm';
  return value.slice(0, 7);

});
Vue.filter('day', function (value) {
  if (value == null) return 'dd';
  return value.slice(8, 10);
});






// WEBPACK FOOTER //
// ./src/main.js